<template>
  <div class="tab-pane active" id="form-step-3">
    <div class="row" v-if="!showCurrencyPref">
      <!-- <div class="col-sm-12">
        <div class="alert alert-info" role="alert">
          To finish your application and to make the most of the benefits of
          working with Smart can you please upload some documents to verify your
          account.
          <br />
          The sooner we are able to verify your identity, the sooner we can put
          you in contact with your account manager.
        </div>
      </div> -->
      <identity-client
        v-for="(client, index) in userIdentitiesUnverified"
        :key="index"
        :contact="client"
        @goNext="goNextStep"
      />

      <div class="col-sm-12" v-if="userIdentitiesUnverified.length > 1">
        <hr />
      </div>
      
      <div class="col-sm-12 mt-2">
        <div class="alert alert-info" role="alert">
          <p class="font-13">
            To complete your ID and Proof of Address verification, you can
            upload any of the following documents:
          </p>
          <template v-if="userIdentitiesUnverified[0] && userIdentitiesUnverified[0].showIDdoc">
          <p class="font-weight-bold font-13">Accepted ID Documents:</p> 
          <p class="font-13">
            e.g. Passport, Driver's Licence, or National ID Card
          </p>
          </template>
          <template v-if="userIdentitiesUnverified[0] && userIdentitiesUnverified[0].showPOA">
          <p class="font-weight-bold font-13">
            Accepted Proof of Address Documents:
          </p>
          <p class="font-13">
           e.g. Utility Bill, Bank Statement, or Official
            Government Correspondence
          </p>
          </template>
          <p class="font-13">
            For the full list of accepted documents,
            <a href="https://docs.idscan.com/library/" target="_blank"
              >click here</a
            >.
          </p>
        </div>
      </div>
      <div class="col-sm-12 mt-2">
        <privacy-policy />
      </div>
      <div class="col-sm-12 mt-3">
        <message-info />
      </div>
      <div class="col-sm-12 mt-3 text-center">
        <p>Haven't got your documentation with you?</p>
        <a href="#" @click.prevent="goNextStep()">Skip this step</a>
      </div>
    </div>
    <currency-pref v-else />
    <Loading v-if="loading" />
  </div>
</template>
<script>
import { mapGetters } from "vuex";

import MessageInfo from "@/components/ui/MessageInfo.vue";
import IdentityClient from "@/components/ui/IdentityClient.vue";
import CurrencyPref from "@/components/steps/CurrencyPreference.vue";
import Loading from "@/components/ui/Loading.vue";
import mixin from "@/components/shared/mixinUtility";
import PrivacyPolicy from "@/components/ui/PrivacyPolicy.vue";
export default {
  name: "Account",
  mixins: [mixin],
  data() {
    return {
      loading: false,
      alreadyVerified: false,
      currContactId: null,
      isSuccess: false,
      showCurrencyPref: false,
    };
  },
  methods: {
    goNextStep() {
      this.resetMessageInfo();
      this.showCurrencyPref = true;
    },
    async setIdentityClient(currContactId, status, isMain) {
      //init user documentation object
      let result = {
        contactId: currContactId,
        alreadyVerified: false,
        showPOA: false,
        showIDdoc: false,
        isMain: isMain,
      };

      if (status == "verified" || status == "invalid") {
        result.alreadyVerified = true;
      } else if (
        status == "reverify" ||
        status == "iddoc-poa" ||
        status == "na"
      ) {
        //show both ID docs upload/POA upload
        result.showPOA = true;
        result.showIDdoc = true;
      } else if (status == "poa" || status == "hide") {
        result.showPOA = true;
      } else if (status == "iddoc") {
        result.showIDdoc = true;
      }
      return result;
    },
    doAlreadyVerified() {
      //skip the step automatically
      this.goNextStep();
      this.loading = false;
    },
  },
  components: {
    Loading,
    MessageInfo,
    "identity-client": IdentityClient,
    "currency-pref": CurrencyPref,
    "privacy-policy": PrivacyPolicy,
  },
  computed: {
    ...mapGetters({
      contactId: "getContactId",
      additionalContactId: "getAdditionalContactId",
      tabs: "getTabs",
      currentActive: "getCurrentActive",
      formData: "getFormData",
      userIdentities: "getUserIdentities",
      actions: "getActions",
      mainContactId: "getMainContactId",
      mainGBGStatus: "getMainUserGBGStatus",
      additionalGBGStatus: "getAdditionalUserGBGStatus",
    }),
    isWidgetMode() {
      return this.$route.name == "kyc";
    },
    userIdentitiesUnverified() {
      return this.userIdentities.filter((user) => !user.alreadyVerified);
    },
  },
  watch: {
    async mainGBGStatus() {
      if (this.mainGBGStatus != "") {
        console.log("watch");
        //call status API or just pass status
        let mainRes = await this.setIdentityClient(
          this.contactId,
          this.mainGBGStatus,
          true
        );
        await this.$store.dispatch("addUserIdentity", mainRes);
        //check if user is already verified
        if (mainRes.alreadyVerified) {
          this.doAlreadyVerified();
        }

        this.loading = false;
      }
    },
  },
  async created() {
    this.resetMessageInfo();
    this.$store.dispatch("setHideNavigation", true);

    if (this.mainGBGStatus == "")
      //gbg still loading
      this.loading = true;
    else {
      //already got response from GBG
      let mainRes = null;
      if (this.contactId != null) {
        mainRes = await this.setIdentityClient(
          this.contactId,
          this.mainGBGStatus,
          true
        );

        //check if user is already verified
        if (mainRes.alreadyVerified) {
          //skip the step automatically
          this.doAlreadyVerified();
        }

        await this.$store.dispatch("addUserIdentity", mainRes);
      }
    }
  },
};
</script>
<style>
.font-13 {
  font-size: 13px !important;
}
</style>